export default __webpack_public_path__ + "static/media/completed_mpp.c00ec267.svg";